<template>
<div v-if="!isCollapsed" class="odr-section-collapsible__content">
    <slot></slot>
</div>
</template>

<script>
import { sectionCollapsibleBus } from '@/utils/section-collapsible-bus';

export default {
    data () {
        return {
            isCollapsed: false,
        };
    },
    computed: {
        qaName () {
            return this.$parent.qaName;
        },
    },
    created () {
        sectionCollapsibleBus.$on(`section-collapse:${this.qaName}`, (state) => {
            this.isCollapsed = state;
        });
    },
};
</script>
